import { faEthereum } from '@fortawesome/free-brands-svg-icons';

import { Cryptocurrency } from '__generated__/globalTypes';
import { FontAwesomeIcon } from 'atoms/icons';
import { SolanaIcon } from 'atoms/icons/SolanaIcon';

type Props = {
  cryptocurrency: Cryptocurrency;
};

export const CryptoIcon = ({ cryptocurrency }: Props) => {
  if (cryptocurrency === Cryptocurrency.WEI) {
    return <FontAwesomeIcon icon={faEthereum} />;
  }
  return <SolanaIcon />;
};
